// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "field-12zq3";
var _4 = "name-1JeKc";
var _5 = "input-1aQP8";
export { _1 as "__esModule", _2 as "mobile", _3 as "field", _4 as "name", _5 as "input" }
export default { "__esModule": _1, "mobile": _2, "field": _3, "name": _4, "input": _5 }
